import { PushPinOutlined as PushPin } from '@mui/icons-material';

const PinOutlined = (): JSX.Element => <PushPin fontSize="inherit" />;

export default PinOutlined;
